// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// import Headway from '';
// ANTD
import Menu from 'antd/lib/menu';
import 'antd/lib/menu/style/css';
import Icon from 'antd/lib/icon';
import 'antd/lib/icon/style/css';
// MODULES

// CONSTANTS & DESTRUCTURING
// ====================================

const SIDER_MENU_ITEMS = [
  {
    key: '/app',
    icon: 'home',
    label: 'Home',
  },
  {
    key: '/app/clients',
    icon: 'team',
    label: 'Clients',
  },
  {
    key: '/app/studio',
    icon: 'shop',
    label: 'My Studio',
  },
  {
    key: '/app/calendar',
    icon: 'calendar',
    label: 'Calendar',
  },
  {
    key: '/app/help',
    icon: 'question-circle-o',
    label: 'Help & Support',
  },
];

const HeadwayRow = () => (
  <div className="sidemenu-bottom">
    <div className="headway-widget-wrapper">
      <span className="headwayappwidget">
        <span className="headway-text">SEE WHAT'S NEW</span>
      </span>
    </div>
  </div>
);

class AppMenu extends React.Component {
  renderLogo = () => (
    <div className="logo">
      <Link to="/app" />
    </div>
  );

  renderMenuItem = ({ key, icon, label }) => (
    <Menu.Item key={key}>
      <Icon className="sider-nav-icon" type={icon} />
      <span className="nav-text">{label}</span>
    </Menu.Item>
  );

  componentDidMount() {
    const Headway = window.Headway;
    // if headway loaded, then run headway init
    if (Headway && Headway.init) {
      Headway.init({
        selector: '.headwayappwidget', // CSS selector where to inject the badge
        account: '7vGpMJ',
      });
    }
  }

  render() {
    return (
      <div style={{ paddingTop: 45 }}>
        {/* {this.renderLogo()} */}
        <Menu
          onClick={key => this.props.handleClick(key)}
          theme="light"
          mode="inline"
          selectedKeys={[this.props.location.pathname]}
          defaultSelectedKeys={[this.props.location.pathname]}
        >
          {SIDER_MENU_ITEMS.map(menuItem => this.renderMenuItem(menuItem))}
        </Menu>
        <HeadwayRow />
      </div>
    );
  }
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/layout/AppLayout/AppMenu/index.js